import { Middleware, configureStore, combineReducers } from '@reduxjs/toolkit';

import { tagsApi } from './api/tags';
import { resourcesApi } from './api/resources';
import { loaderReducer } from './slices/loader';
import { categoriesApi } from './api/categories';

const apis = [tagsApi, categoriesApi, resourcesApi];

const appReducer = combineReducers({
  loader: loaderReducer,
  ...Object.fromEntries(apis.map((api) => [api.reducerPath, api.reducer])),
});

const rootReducer = (state: any, action: any) => appReducer(state, action);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apis.map((api) => api.middleware as Middleware)
    ),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
